// JavaScript code for acf_blocks/programme-how-it-works component
(($) => {

    "use strict";
    if (!$('.acf-blocks-programme-how-it-works').length) {
        return
    }
    console.log("acf_blocks/programme-how-it-works scripts loaded...");

    $('.acf-blocks-programme-how-it-works .navigational-tabs').on('click', 'li', function() {
        let index = $(this).index();
        $(this).addClass('active')
            .siblings()
            .removeClass('active');

        $(this).parent()
            .next('.tabs-contents-container')
            .find('.tab-content')
            .removeClass('active')
            .eq(index)
            .addClass('active');
    });

})(jQuery);